// Colour-coded run/step status pill — a coloured dot + label tinted to the
// state, so a run's status reads at a glance in the run-history grids and the
// run-detail blade. Colours come from the shared runStatus map (same palette as
// the Home live-activity tile).

import { statusColor, statusLabel } from '../lib/runStatus';
import { StatusPill } from './StatusPill';

interface RunStatusBadgeProps {
  status: string;
}

export function RunStatusBadge({ status }: RunStatusBadgeProps) {
  return <StatusPill color={statusColor(status)}>{statusLabel(status)}</StatusPill>;
}
